import axios from 'axios'
import AuthManager from  '@/components/auth/AuthManager'
import UserSessionService from "./userSessionService"

class Auth {
    constructor () {
        if (!this.instance)
        {
            this.addInterceptors()
            this.addHttpHeaders()
            this.instance = this
            this.features = {}
        }
        return this.instance
    }

    setFeatures (features) {
        this.features = features || {};
    }

    setAuthHeader (response) {
        let authHeader = response.headers['authorization']
            ? response.headers['authorization']
            : undefined
        if (!authHeader) {
            return ''
        } else {
            authHeader = authHeader.replace(/^Bearer /, '')
            // Note: Don't add the auth header in here, or the API Gateway can't refresh the access token for us
            // axios.defaults.headers.common["authorization"] = "Bearer " + authHeader;
            return authHeader
        }
    }

    addHttpHeaders () {
        if (axios) {
            // axios.defaults.withCredentials = true
            // axios.defaults.headers.common['appId'] = '5ae73246d9c4184d7ca13d11'
            // axios.defaults.headers.common['appName'] = 'NetMet'
        }
    }

    addCustomerHeader (customer) {
        if (axios) {
            axios.defaults.headers.common['Customer'] = customer;
        }
    }

    addInterceptors () {
        let auth = this
        if (axios) {
            // Intercept axios responses in order to catch 401 Unauthorized error and redirect to login page
            axios.interceptors.response.use(
                function (response) {
                    auth.setAuthHeader(response)
                    return response
                },
                function (error) {
                    if (error && error.response && (error.response.status === 401 || error.response.status === 302))
                    {
                        console.error ('Received response status ' + error.response.status + ', displaying login page, response:', error.response)

                        // If we hit a 401 on the sensus-auth-provider, we don't need to force a logout
                        // If another API call hits a 401 (subsequently fetched when this is), we'll log the user out.
                        if (typeof error?.config?.url === 'string' && error.config.url.includes('/api/sensus-auth-provider/v1')) {
                            return null
                        }

                        auth.logout()
                        return null  // We should never get here
                    }
                    else
                    {
                        if (error.message !== "canceled")
                        {
                            console.warn ('Rejecting route navigation due to unknown network error.  Error obj:  ' + error)
                        }
                        return Promise.reject(error)
                    }
                }
            )
        }
    }

    logout () {
        AuthManager.logout()
    }

    hasNetmetPermission (userObj) {

        let permissions = [
            'MANAGE_SYS_PREFS',
            'VIEW_SYS_PREFS',
            'VIEW_SYS_HISTORY',
            'MANAGE_TOWERS',
            'VIEW_TOWERS',
            'DELETE_TOWERS',
            'CREATE_ALARMS',
            'MANAGE_ALARMS',
            'VIEW_ALARMS',
            'MANAGE_CUSTOMERS',
            'VIEW_CUSTOMERS',
            'MANAGE_FREQUENCY_MAPPINGS',
            'VIEW_FREQUENCY_MAPPINGS',
            'DELETE_RADIOS',
            'MANAGE_RADIOS',
            'VIEW_RADIOS',
            'MANAGE_DEVICES',
            'VIEW_DEVICES',
            'VIEW_METRICS',
            'MANAGE_TASKS',
            'VIEW_TASKS',
            'VIEW_CHANNEL_BALANCING',
            'MANAGE_CHANNEL_BALANCING',
            'VIEW_BTS_PASSWORDS'
        ]

        // Make sure the user has at least some valid NETMET role or Xylem admin role
        return (userObj.permissions.some(role => {
            return role === 'XYLEM_ADMIN' || role.indexOf('NETMET') === 0 || permissions.indexOf(role) !== -1
        }))
    }

    /**
     * Is the server configured for Arqiva
     * @returns {boolean} true if yes, false if no
     */
    isArqiva ()
    {
        return this.features.enabledHardware === "SPR" || this.features.enabledHardware === "NA_AND_SPR"
    }

    /**
     * Is the server configured for North America
     * @returns {boolean} true if yes, false if no
     */
    isNorthAmerica ()
    {
        return this.features.enabledHardware === "NA" || this.features.enabledHardware === "NA_AND_SPR"
    }

    /**
     * Is the server configured for the channel balancing feature
     * @returns {boolean} true if yes, false if no
     */
    isChannelBalancingEnabled ()
    {
        return !!(this.features.netTuneEnabled && this.features.tuning.enabled && this.features.tuning.channelBalancing.enabled)
    }

    /**
     * Does the current customer have tuning enabled
     * @returns {boolean} true if ues, false if no
     */
    isConfigFeatureEnabled ()
    {
        let customer = UserSessionService.getCurrentCustomer()
        if (customer?.features)
        {
            return (customer.features.includes ("NETCONFIGURE"))
        }
        return (false)
    }

    /**
     * Is the server configured for the tuning balancing feature
     * This is a temp function only for use on the admin, customer add/update dialog.
     * @returns {boolean} true if yes, false if no
     */
    isGlobalTuningEnabled ()
    {
        return !!this.features.netTuneEnabled
    }

    /**
     * Does the current customer have tuning enabled
     * @returns {boolean} true if ues, false if no
     */
    isTuningFeatureEnabled ()
    {
        let customer = UserSessionService.getCurrentCustomer()
        if (customer?.features)
        {
            return (customer.features.includes ("NETTUNE"))
        }
        return (false)
    }

    isGlobalAlarmFeatureEnabled ()
    {
        return this.features.globalAlarmsEnabled
    }

    isAlarmSuppressionFeatureEnabled ()
    {
        return this.features.alarmSuppressionsEnabled
    }

    isHeliosSupportEnabled ()
    {
       return this.features.heliosSupportEnabled
    }
}

export default new Auth()
